import { useTranslations } from "next-intl";
import PlusIcon from "@/shared/ui/icon/PlusIcon";

export default function AgentDataUploaderAdd({
  addItem,
}: {
  addItem: () => void;
}) {
  const t = useTranslations("Demo");

  return (
    <div className="flex w-full flex-col items-center justify-center gap-2 rounded-md border border-gray-100 bg-white py-[20px] text-primary-dark transition-all hover:border-primary-dark">
      <button
        className={
          "flex h-full w-full flex-row-reverse items-center justify-center gap-[12px] main:flex-col main:gap-[28px]"
        }
        onClick={addItem}
      >
        <span className={"text-title1 font-[600]"}>{t("데이터 추가하기")}</span>
        <PlusIcon />
      </button>
    </div>
  );
}
